import React from "react";
import { Link, NavLink } from "react-router-dom";
import { getAssetUrl } from "../config";
import { useContact } from "../context/ContactContext";
import { useSocial } from "../context/SocialMediaContext";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { contact } = useContact();
  const { social } = useSocial();
  const emailPrimary = contact?.email_primary || "info@kudosta.com";
  const emailSecondary = contact?.email_secondary || "hr@kudosta.com";
  const phonePrimaryRaw = contact?.contact_primary || contact?.whatsapp_primary || "+917597544999";
  const phoneSecondaryRaw = contact?.contact_secondary || "+14354141624";
  const phonePrimaryTel = phonePrimaryRaw.toString().replace(/\D/g, "");
  const phoneSecondaryTel = phoneSecondaryRaw.toString().replace(/\D/g, "");
  const addressPrimary = contact?.address_primary || "100-A, Main Hastinapur Colony, Karni Palace Road, Vaishali Nagar, Jaipur, Rajasthan 302034";
  const addressPrimaryMapLink = contact?.map_url_primary || "https://goo.gl/maps/bqZxcqFpeRa3p66JA";
  return (
    <>
      <footer className="site-footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand footer-col">
              <Link to="/" className="footer-logo">
                <img alt="Kudosta" src={getAssetUrl('kds-assets/img/Kudosta-logo-white-orange.png')} />
              </Link>
              <p className="footer-about">
                We design and build custom software that fits the way your
                business really works.
              </p>
              <div className="footer-social">
                {/* Render social links from API if available, otherwise fall back to static links */}
                {Array.isArray(social) && social.length ? (
                  social.map((s) => (
                    <a
                      key={s.id}
                      href={s.social_media_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      dangerouslySetInnerHTML={{ __html: s.social_media_icon }}
                    />
                  ))
                ) : (
                  <>
                    <Link to="https://www.facebook.com/kudosta/" target="_blank">
                      <svg fill="currentColor" viewBox="0 0 24 24">
                        <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z"></path>
                      </svg>
                    </Link>
                    <Link to="https://www.instagram.com/kudostallp/" target="_blank">
                      <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                        <rect height="20" rx="5" width="20" x="2" y="2"></rect>
                        <circle cx="12" cy="12" r="4"></circle>
                        <circle cx="17.5" cy="6.5" fill="currentColor" r="1" stroke="none"></circle>
                      </svg>
                    </Link>
                    <Link to="https://twitter.com/kudostaseo" target="_blank">
                      <svg fill="currentColor" viewBox="0 0 24 24">
                        <path d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-5.21-6.82-5.96 6.82H1.68l7.73-8.84L1.25 2.25h6.83l4.71 6.23 5.45-6.23zm-1.16 17.52h1.83L7.08 4.13H5.12l11.96 15.64z"></path>
                      </svg>
                    </Link>
                    <Link to="https://www.linkedin.com/company/kudosta-pvt-ltd" target="_blank">
                      <svg fill="currentColor" viewBox="0 0 24 24"><path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3zm6 0h3.8v1.71h.05c.53-1 1.83-2.06 3.77-2.06 4.03 0 4.78 2.16 4.78 5.36V21h-4v-5.28c0-1.26-.03-2.88-1.75-2.88-1.76 0-2.03 1.37-2.03 2.79V21H9z"></path></svg>
                    </Link>
                  </>
                )}
              </div>
            </div>
            <div className="footer-col">
              <h4>Services</h4>
              <div className="links">
                <NavLink to="/custom-php-software-solutions">Custom PHP</NavLink>
                <NavLink to="/wordpress-development">WordPress</NavLink>
                <NavLink to="/woocommerce-development">WooCommerce</NavLink>
                <NavLink to="/react-js-development">React JS</NavLink>
                <NavLink to="/website-design-&-development">
                  Website Design &amp; Development
                </NavLink>
                <NavLink to="/digital-marketing-services">Digital Marketing</NavLink>
                <NavLink to="/managed-it-services">Managed IT</NavLink>
              </div>
            </div>
            <div className="footer-col">
              <h4>Company</h4>
              <div className="links">
                <NavLink to="/" end>Home</NavLink>
                <NavLink to="/about">About</NavLink>
                <NavLink to="/portfolio">Portfolio</NavLink>
                <NavLink to="/blog">Blog</NavLink>
                <NavLink to="/career">Career</NavLink>
                <NavLink to="/contact">Contact</NavLink>
              </div>
            </div>
            <div className="footer-col">
              <h4>Get in touch</h4>
              <div className="links">
                <a className="footer-contact-link" href={`mailto:${emailPrimary}`}>
                  <svg aria-hidden="true" focusable="false" fill="none" viewBox="0 0 24 24">
                    <rect height="16" rx="2" stroke="currentColor" strokeWidth="1.7" width="20" x="2" y="4" />
                    <path d="m3 6 9 7 9-7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" />
                  </svg>
                  {emailPrimary}
                </a>
                <a className="footer-contact-link" href={`mailto:${emailSecondary}`}>
                  <svg aria-hidden="true" focusable="false" fill="none" viewBox="0 0 24 24">
                    <rect height="16" rx="2" stroke="currentColor" strokeWidth="1.7" width="20" x="2" y="4" />
                    <path d="m3 6 9 7 9-7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" />
                  </svg>
                  {emailSecondary}
                </a>
                <a className="footer-contact-link" href={`tel:+${phonePrimaryTel}`}>
                  <svg aria-hidden="true" focusable="false" fill="none" viewBox="0 0 24 24">
                    <path d="M7 3H4a1 1 0 0 0-1 1c0 9.4 7.6 17 17 17a1 1 0 0 0 1-1v-3l-5-2-2 2a14 14 0 0 1-8-8l2-2-2-5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" />
                  </svg>
                  {phonePrimaryRaw}
                </a>
                <a className="footer-contact-link" href={`tel:+${phoneSecondaryTel}`}>
                  <svg aria-hidden="true" focusable="false" fill="none" viewBox="0 0 24 24">
                    <path d="M7 3H4a1 1 0 0 0-1 1c0 9.4 7.6 17 17 17a1 1 0 0 0 1-1v-3l-5-2-2 2a14 14 0 0 1-8-8l2-2-2-5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" />
                  </svg>
                  {phoneSecondaryRaw}
                </a>
                <Link
                  className="footer-address footer-contact-link"
                  to={addressPrimaryMapLink}
                  target="_blank"
                >
                  <svg aria-hidden="true" focusable="false" fill="none" viewBox="0 0 24 24">
                    <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.7" />
                    <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.7" />
                  </svg>
                  {addressPrimary}
                </Link>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-note">
              © {currentYear} Kudosta Solutions LLP. All rights reserved.
            </div>
            <div className="footer-legal">
              <NavLink to="/privacy-policy">Privacy Policy</NavLink>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
